exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-2ab4259a] .el-form-item__label{text-align:right}[data-v-2ab4259a] .el-tabs__content{height:calc(100% - 55px);overflow-y:auto}", ""]);

// exports
